import { render, staticRenderFns } from "./auto-provlarm.vue?vue&type=template&id=606332f0"
import script from "./auto-provlarm.vue?vue&type=script&lang=js"
export * from "./auto-provlarm.vue?vue&type=script&lang=js"
import style0 from "./auto-provlarm.vue?vue&type=style&index=0&id=606332f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports